// extracted by mini-css-extract-plugin
export default {"notificationEditor":"NLWUX","toolbar":"UQgbm","toolbarDivider":"rXSIl","editorContainer":"D5ENJ","fieldTag":"PXSst","closeIcon":"aKuoL","addFieldDropdown":"i2gRH","link":"w36xA"};